exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-label {\r\n  font-size: small;\r\n}\r\n\r\n.dropdown-menu {\r\n  max-height: 300px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.filter-list {\r\n  background-color: white;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 5px;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  overflow-x: auto;\r\n  /*width: max-content;*/\r\n  margin-top: 5px;\r\n  width: 100%;\r\n}\r\n\r\n.component-background {\r\n  overflow: unset;\r\n}\r\n\r\n.selected {\r\n  background-color: #171514;\r\n  color: white;\r\n}\r\n\r\n.selected:hover {\r\n  background-color: #373736;\r\n  ;\r\n}\r\n\r\n.filter-list {\r\n  background-color: white;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 5px;\r\n  height: 180px;\r\n  overflow-y: auto;\r\n  width: -webkit-max-content;\r\n  width: -moz-max-content;\r\n  width: max-content;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.full-width {\r\n  width: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-group/create-group.component.css
// module id = ../../../../../src/app/content-page/admin/create-group/create-group.component.css
// module chunks = main